module.exports = __webpack_public_path__ + "img/hs_logo_text.4a68ffea.svg";